var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DownloadSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.15313 10.8469C8.05119 10.7405 7.98198 10.6071 7.95372 10.4625C7.92547 10.3179 7.93936 10.1682 7.99375 10.0312C8.04968 9.89299 8.14555 9.77455 8.26913 9.69106C8.3927 9.60756 8.53836 9.5628 8.6875 9.5625H11.875V3.75C11.875 3.55109 11.954 3.36032 12.0947 3.21967C12.2353 3.07902 12.4261 3 12.625 3C12.8239 3 13.0147 3.07902 13.1553 3.21967C13.296 3.36032 13.375 3.55109 13.375 3.75V9.5625H16.5625C16.7116 9.5628 16.8573 9.60756 16.9809 9.69106C17.1044 9.77455 17.2003 9.89299 17.2562 10.0312C17.3106 10.1682 17.3245 10.3179 17.2963 10.4625C17.268 10.6071 17.1988 10.7405 17.0969 10.8469L13.1594 14.7844C13.016 14.923 12.8244 15.0005 12.625 15.0005C12.4256 15.0005 12.234 14.923 12.0906 14.7844L8.15313 10.8469ZM20.875 13.5C20.6761 13.5 20.4853 13.579 20.3447 13.7197C20.204 13.8603 20.125 14.0511 20.125 14.25V19.5H5.125V14.25C5.125 14.0511 5.04598 13.8603 4.90533 13.7197C4.76468 13.579 4.57391 13.5 4.375 13.5C4.17609 13.5 3.98532 13.579 3.84467 13.7197C3.70402 13.8603 3.625 14.0511 3.625 14.25V19.5C3.625 19.8978 3.78304 20.2794 4.06434 20.5607C4.34564 20.842 4.72718 21 5.125 21H20.125C20.5228 21 20.9044 20.842 21.1857 20.5607C21.467 20.2794 21.625 19.8978 21.625 19.5V14.25C21.625 14.0511 21.546 13.8603 21.4053 13.7197C21.2647 13.579 21.0739 13.5 20.875 13.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1fc66761dab6ba50fc6a0261f28ef8da.svg";
export { ForwardRef as ReactComponent };